export default __webpack_public_path__ + "static/icon-adjustable-coverage-ce4b9a7152e1a86e2ae5382cf35ea0c4.webp";